import { useEffect, useState } from 'react';
import { usePostHog } from 'posthog-js/react';

import { selectUser } from '../store/auth.slice';

import { useAppSelector } from './redux';

export const useFeatureFlagEnabled = (featureFlag: string) => {
  const posthog = usePostHog();
  const user = useAppSelector(selectUser);
  const [isEnabled, setIsEnabled] = useState(false);

  useEffect(() => {
    if (!posthog || !featureFlag || !user?.id) {
      setIsEnabled(false);
      return;
    }

    const updateFlagState = () => {
      setIsEnabled(Boolean(posthog.isFeatureEnabled(featureFlag)));
    };

    const unsubscribe = posthog.onFeatureFlags(updateFlagState);
    updateFlagState();

    return () => {
      unsubscribe?.();
    };
  }, [featureFlag, posthog, user?.id]);

  return isEnabled;
};
